import React from "react";

import PropTypes from "prop-types";

import RbAutocompleteControl from "../RbAutocompleteControl";
import RbField from "../RbField";

const emptyArray = [];
function RbSelectField(props) {
  const { fieldName, multiple, required, ...other } = props;

  const validate = React.useCallback(
    (value) => {
      if ((!value || value.length === 0) && required) {
        return "Required field";
      }

      return undefined;
    },
    [required]
  );

  return (
    <RbField
      Component={RbAutocompleteControl}
      defaultEmptyValue={multiple ? emptyArray : null}
      fieldName={fieldName}
      multiple={multiple}
      required={required}
      validate={validate}
      {...other}
    />
  );
}

RbSelectField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  required: PropTypes.bool,
};

RbSelectField.defaultProps = {
  multiple: undefined,
  required: undefined,
};

export default React.memo(RbSelectField);
